import formModel from './formModel';

const moment = require('moment');

const {
    formField: {
        codigosLocalidad,
        vigencia,
        fechaVigencia,
        equipoTelematica,

        afinidad,
        img_afinidad,

        //    EMISION
        vigenciaDesde,
        vigenciaHasta,
        frecuenciaPago,
        cuotas,
        ajusteAutomatico,
        formaDePago,
        infoDePago: {
            numeroCbu,
            marcaTarjeta,
            numeroTarjeta,
            vencimientoTarjeta,
        },
        emailDespachoElectronico,
        despachoElectronico,
        comentariosSolicitud,
        moduloCobertura,
        scoring: {
            garage,
            edadConductores,
            kmsAnuales,
        },
        rol,
        personaJuridica,
        dni,
        cuit,
        nombre,
        apellido,
        fechaNacimiento,
        estadoCivil,
        sexo,
        domicilio,
        codigoArea,
        telefono,
        email,
        situacionImpositiva,
        categoriaMonotributo,
        actividadPrincipal,
        lugarNacimiento,
        motovehiculo: {
            patente,
            motor,
            chasis,
            marca,
            version,
            anio,
            usoVehiculo,
            valor,
            valorAdicional,
            ceroKm,
            equipoDeRastreo,
            inspeccionPrevia: {
                fechaInspeccion,
                tipoCombustible,
                aspectoGeneral,
                estadoCristales,
                resultadoInspeccion,
                kilometraje,
                aspectoPintura,
                tipoPintura,
                aspectoChapa,
                aspectoNeumaticos,
                aspectoTapizado,
                colorTapizado,
                tipoTapizado,
                colorVehiculo,
                tipoLlantas,
                archivos
            },
        },
    }
} = formModel;

export default {
    [ceroKm.name]: 'false',
    [codigosLocalidad.name]: '',
    [vigencia.name]: '1',
    [fechaVigencia.name]: '',
    [equipoTelematica.name]: '',
    [afinidad.name]: '',
    [img_afinidad.name]: '',

    premium: '',
    [vigenciaDesde.name]: moment().format('YYYY-MM-DD'),
    [vigenciaHasta.name]: moment().add(1, "Y").format("YYYY-MM-DD"),
    [frecuenciaPago.name]: '5',
    [cuotas.name]: '',
    [ajusteAutomatico.name]: '',
    [formaDePago.name]: '4',
    infoDePago: {
        [numeroCbu.name]: '',
        [marcaTarjeta.name]: '',
        [numeroTarjeta.name]: '',
        [vencimientoTarjeta.name]: '',
    },
    [emailDespachoElectronico.name]: '',
    [despachoElectronico.name]: 'false',
    [comentariosSolicitud.name]: '',
    [moduloCobertura.name]: '',
    scoring: {
        [garage.name]: true,
        [edadConductores.name]: false,
        [kmsAnuales.name]: false,
    },
    bienesAsegurados: [],
    //CLIENTE
    [rol.name]: '2',
    [personaJuridica.name]: '0',
    [dni.name]: '',
    [cuit.name]: '',
    [nombre.name]: '',
    [apellido.name]: '',
    [fechaNacimiento.name]: '',
    [estadoCivil.name]: '2',
    [sexo.name]: '',
    [domicilio.name]: '',
    [codigoArea.name]: '',
    [telefono.name]: '',
    [email.name]: '',
    [situacionImpositiva.name]: '4',
    [categoriaMonotributo.name]: '1',
    [actividadPrincipal.name]: '10001',
    [lugarNacimiento.name]: 'Cordoba',

    motovehiculo: {
        [patente.name]: '',
        [motor.name]: '',
        [chasis.name]: '',
        [marca.name]: '',
        [version.name]: '',
        [anio.name]: '',
        [usoVehiculo.name]: '2',
        [valor.name]: '',
        [valorAdicional.name]: 0,
        [ceroKm.name]: 'true',
        [equipoDeRastreo.name]: '',
        inspeccionPrevia: {
            [fechaInspeccion.name]: moment().format('YYYY-MM-DD'),
            [tipoCombustible.name]: '1',
            [aspectoGeneral.name]: '2',
            [estadoCristales.name]: 'SinProblemas',
            [resultadoInspeccion.name]: '1',
            [kilometraje.name]: '15000',
            [aspectoPintura.name]: '2',
            [tipoPintura.name]: '2',
            [aspectoChapa.name]: '2',
            [aspectoNeumaticos.name]: '2',
            [aspectoTapizado.name]: '2',
            [colorTapizado.name]: '13',
            [tipoTapizado.name]: '2',
            [colorVehiculo.name]: 'A declarar',
            [tipoLlantas.name]: '2',
            [archivos.name]: [],
        },
    }
};
